import { useState } from 'react';
import Container from '@ui/container/container';
import Text from '@ui/text/text/text';
import Button from '@ui/buttons/button/button';
import getThemeColorCSSVariable from '@/utils/colors/get-theme-color-css-variable';
import { EColorVariablesV2 } from '@/types/theme-packs.types';
import { StaticVideo } from '@/types/video.types';
import InputWithOverlay from '@ui/input-with-overlay/input-with-overlay';

type TSessionVodLinkInfoProps = {
  sessionVideo: StaticVideo | null;
  isEditMode?: boolean;
  onReset?: () => void;
  onSave?: (linkUrl: string, videoName: string) => void;
};

const SessionVodLinkInfo = ({ sessionVideo, isEditMode = false, onReset, onSave }: TSessionVodLinkInfoProps) => {
  const [linkUrl, setLinkUrl] = useState(sessionVideo?.type === 'url' ? sessionVideo?.source : '');
  if (isEditMode) {
    return (
      <Container
        className="flex-column ai-center gap-4"
        height="84px"
        width="100%"
        background="var(--global-cont-1)"
        padding="12px"
        borderRadius="8px"
      >
        <Container className="flex ai-center jc-space-between padding-h-8 gap-4" width="100%">
          <Text className="L2" color="var(--gray-500)">
            Add URL
          </Text>
          <Container className="flex ai-center gap-12">
            <Button padding="0" onClick={onReset}>
              <Text className="S2" color={getThemeColorCSSVariable(EColorVariablesV2.primary)}>
                Reset
              </Text>
            </Button>
            {/* TODO: implement add thumbnail
            <Text className='L2' color="var(--global-cont-3)">|</Text>
            <Button padding='0' onClick={() => {}}>
              <Text className="S2" color={getThemeColorCSSVariable(EColorVariablesV2.primary)}>
                Add thumbnail
              </Text>
            </Button>
            */}
          </Container>
        </Container>
        <InputWithOverlay
          inputHeight="32px"
          wrapperClass="width-100-percent"
          inputProps={{
            placeholder: 'Enter video URL',
            className: 'P2',
            value: linkUrl,
            onChange: (e: React.ChangeEvent<HTMLInputElement>) => setLinkUrl(e.target.value),
          }}
          onDebounce={(value) => {
            if (value && onSave) {
              onSave(value, 'Linked Video');
            }
          }}
          debounceTime={250}
        />
      </Container>
    );
  }

  if (!sessionVideo) return null;

  return (
    <Container className="flex ai-center jc-flex-start" borderRadius="8px" padding="12px" height="84px" width="100%">
      <Container className="flex ai-center jc-center gap-12" height="100%" width="100px">
        {sessionVideo.thumbnail_url && sessionVideo.thumbnail_url.trim() ? (
          <img src={sessionVideo.thumbnail_url} style={{ maxWidth: '100%', maxHeight: '100%', borderRadius: '8px' }} />
        ) : (
          <Container
            height="100%"
            width="100%"
            borderRadius="8px"
            border="2px dashed var(--gray-600)"
            background="var(--gray-800)"
          />
        )}
      </Container>
      <Container className="flex-column" borderRadius="8px" padding="8px" width="100%">
        <Text className="S3" clamp={1} color="var(--gray-100)">
          {sessionVideo?.source}
        </Text>
        <Text className="L2" color="var(--gray-300)">
          URL
        </Text>
      </Container>
    </Container>
  );
};

export default SessionVodLinkInfo;
